import React, { useEffect } from "react";
import s from "./Drawer.module.css";
import { clsx } from "../../utils/clsx";
import { keys } from "../../utils/a11y";
import { useComponentDefaults } from "../../Provider";

export default function Drawer(props) {
  const merged = useComponentDefaults('Drawer', props, {
    open: false,
    side: 'right',
    closeOnEsc: true,
    closeOnOutsideClick: true,
  });
  const {
    open,
    onClose,
    side = 'right',
    className,
    overlayClassName,
    children,
    closeOnEsc = true,
    closeOnOutsideClick = true,
  } = merged;

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (closeOnEsc && e.key === keys.ESC) onClose?.(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [open, onClose, closeOnEsc]);

  if (!open) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && closeOnOutsideClick) onClose?.();
  };

  return (
    <div
      className={clsx(s.overlay, s[side], overlayClassName)}
      onClick={handleOverlayClick}
    >
      <div className={clsx(s.drawer, className)} role="dialog" aria-modal="true">
        {children}
      </div>
    </div>
  );
}
